import React, { useContext } from "react";

import { useTranslation } from "react-i18next";

import { WalletIcon } from "@components/icons/WalletIcon";
import WalletTag from "@components/shared/WalletTag";
import { Bet } from "@models";
import { BetDetailsModalStoreContext } from "@state/context/my-bets/BetDetailsModalStoreContext";
import { shouldUseSlipStatusInstead } from "@utils/offer/shouldUseSlipStatusInstead";
import { observer } from "mobx-react";

import { BetDetailsModalShareButton } from "../common";
import FreebetTag from "@components/shared/FreebetTag";

export const BetDetailsModalHeader = observer(
	function BetDetailsModalHeader(props: { betSlip: Bet | null }) {
		const store = useContext(BetDetailsModalStoreContext);

		const { t } = useTranslation();

		const { betSlip } = props;

		if (!betSlip) {
			return null;
		}

		const betAccountTypeAbrv =
			store.rootStore.userAuthStore.userAccounts?.find(
				(wallet) =>
					wallet.accountTypeId === betSlip.bettingAccountTypeId
			)?.abrv || null;

		let betStatus = betSlip.betStatus;
		let tagClasses = `bet__tag tag tag--tny tag--bet--${betStatus?.abrv}`;

		if (shouldUseSlipStatusInstead(betSlip)) {
			betStatus = betSlip.betSlipStatus;
			tagClasses = `bet__tag tag tag--tny tag--slip--${betStatus?.abrv}`;
		}

		return (
			<div className="popup__header popup--details__header">
				<div className="popup--details__row">
					<div className="popup__title popup--details__heading">
						<div className="popup--details__title">
							{betSlip.hasBetBuilder && (
								<i className="popup--details__title__icon u-icon u-icon--sml u-icon--bb--active" />
							)}
							<span className="popup--details__title__inner popup__title__inner">
								ID {props.betSlip?.betSlipNumber}
							</span>
						</div>

						{props.betSlip && !store.isShareActive && (
							<BetDetailsModalShareButton
								bet={props.betSlip}
								store={store}
								btnTiny
							/>
						)}
					</div>

					<div className="popup--details__tags">
						<span className={tagClasses}>
							{betStatus.name}{" "}
							{betSlip.isLive && (
								<>
									{" "}
									-{" "}
									{t(
										"ACC_STATEMENT.BET_DETAILS.D_LIVE"
									).toUpperCase()}
								</>
							)}
							{betSlip.isBonus && (
								<> ({t<string>("COMMON.BONUS")})</>
							)}
						</span>
                        
                        
                        {betSlip.shouldShowBetSlipStatus && (
                            <span
                                className={
                                    "bet__tag tag tag--tny tag--slip--" +
                                    betSlip.betSlipStatus.abrv
                                }
                            >
                                {betSlip.betSlipStatus.name}
                            </span>
                        )}

                        <FreebetTag isFreebet={betSlip.isFreebet} />

						<WalletTag
							isWalletManuallyDisabled={
								betSlip.isWalletManuallyDisabled || false
							}
						/>

						<WalletIcon
							bettingAccountTypeAbrv={betAccountTypeAbrv}
							isWalletManuallyDisabled={
								betSlip.isWalletManuallyDisabled || false
							}
						/>
					</div>
				</div>

				<button
					type="button"
					onClick={() => {
						store.closeModal();
						store.onShareClose();
					}}
					className="popup__close btn btn--square btn--square--sml btn--primary--inverted"
				>
					<i className="u-icon u-icon--tny u-icon--close u-color--text--secondary" />
				</button>
			</div>
		);
	}
);
